export const oldOrigin = "https://wp.elvent.shop"
export const newOrigin = "https://elvent-frontend.vercel.app"
export const assetsFolder = "/_next"

export function isOnNewStack(url: { pathname: string; search: string }) {
  const relativeUrl = url.pathname + url.search

  if (relativeUrl.startsWith("/api/")) {
    return true
  }

  if (
    // wrap-line
    relativeUrl.includes(".php") ||
    relativeUrl.includes("wp-") ||
    relativeUrl.includes("wc-") ||
    false
  ) {
    return false
  }

  return true
}
